import { useEffect, useState, useRef } from 'react'
import { accountsSdk } from '@livechat/accounts-sdk'
import { FullStoryAPI } from 'react-fullstory'
import axios from 'axios'
import firebase from '../firebase'

const initialAuthState = {
  isLoggingIn: true,
  isLoggedIn: false,
  isAdmin: false,
  slack: null,
  groups: [],
  agentData: null,
  currentUser: null,
  firebaseToken: null,
  notifications: [],
  appName: null,
  version: null,
  isGenericAgent: false,
}

const useAuth = (connect, disconnect, update, type = 'code') => {
  const [auth, setAuth] = useState(initialAuthState)
  const instance = useRef(null)

  useEffect(() => {
    setAuth(initialAuthState)

    instance.current = accountsSdk.init({
      client_id: process.env.REACT_APP_CLIENT_ID,
      response_type: type,
      onIdentityFetched: async (error, data) => {
        try {
          if (data && (data.code || data.access_token)) {
            let tokenData

            switch (type) {
              case 'code': {
                tokenData = await axios.get(
                  `${process.env.REACT_APP_API_INTEGRATION_URL}/install`,
                  {
                    params: {
                      code: data.code,
                    },
                  }
                )
                break
              }

              case 'token': {
                tokenData = await axios.post(
                  `${process.env.REACT_APP_API_INTEGRATION_URL}/auth`,
                  {
                    access_token: data.access_token,
                  }
                )
                break
              }

              default:
            }

            const appName = tokenData.data.name
            const firebaseToken = tokenData.data.token
            let firebaseApp

            switch (appName) {
              case 'slack3':
                firebaseApp = firebase.slack3
                break

              case 'slack2':
                firebaseApp = firebase.slack2
                break

              default:
                firebaseApp = firebase.slack
                break
            }
            await firebaseApp.auth().signInWithCustomToken(firebaseToken)
            const currentUser = await firebaseApp
              .auth()
              .currentUser.getIdTokenResult()

            const db = firebaseApp.firestore()
            const licensesRef = db.collection('licenses').doc(`${data.license}`)
            const doc = await licensesRef.get()
            const docData = doc.data()

            setAuth({
              isLoggingIn: false,
              isLoggedIn: true,
              isAdmin: currentUser.claims.admin,
              slack: docData ? docData.slack : null,
              groups: currentUser.claims.groups,
              agentData: data,
              currentUser,
              firebaseToken,
              appName,
              version: docData ? docData.version : null,
              isGenericAgent: docData ? docData.is_generic_agent : false,
            })

            if (data.license && data.entity_id) {
              FullStoryAPI('identify', data.license, {
                displayName: data.entity_id,
                email: data.entity_id,
              })
            }
          } else {
            setAuth(initialAuthState)
            // instance.current.openPopup()
            window.location.href = `${process.env.REACT_APP_ACCOUNTS_URL}?response_type=token&client_id=${process.env.REACT_APP_CLIENT_ID}&redirect_uri=${window.location.href}`
          }
        } catch (err) {
          console.log(err)
          setAuth(initialAuthState)
        }
      },
    })
  }, [connect, disconnect, update, type])

  return {
    ...auth,
    instance: instance.current || null,
  }
}

export default useAuth
